export default __webpack_public_path__ + "static/media/icon-3.f9fa2902.png";